import _ from "lodash";
import hookFns from "./hookFns";

export default function makePagingExpandable(
  $grid = $(), // grid already wrapped in jquery
  {
    gridId = "",
    pagesize = 5,
    pagesizeoptions = ["5", "10", "20", "50"],
    source = { _source: null }, // jqxGrid data source
  } = {}
) {
  let processing = false;
  let increment = pagesize;

  if (!source || !source._source) {
    throw new Error(
      "Incompatible source. Provide the source returned from a $.jqx.dataAdapter()."
    );
  }

  // Bug in jqxGrid with filtertypes: 'list', it adds empty filters to the filter array
  // This is a workaround to remove those empty filters
  // source._source.filter = (filters, recordsArray) => {
  //     (filters ?? []).forEach(function (x) {
  //       if(x && x.filter.getfilters && x.filter.getfilters().length === 0) {
  //         $grid.jqxGrid('removefilter', x.datafield)
  //       }
  //   });

  //   $grid.jqxGrid("updatebounddata", "filter");
  // }

  const $btn = $(`<button>`, {
    style:
      "float: right; background-color: inherit; padding: 4px; border: 1px solid #555",
    text: "Load More",
  });

  const setBtnDisableState = (showLoading = false, tooltip = "") => {
    $btn.css({ opacity: ".5" });
    $btn.text(showLoading ? "Loading..." : "Load More");
    $btn.attr("disabled", "disabled");

    if (tooltip) {
      $btn.attr("title", tooltip);
    }
  };

  const setBtnEnableState = () => {
    $btn.css({ opacity: "1" });
    $btn.text("Load More");
    $btn.removeAttr("disabled");
  };

  $grid.on("bindingcomplete", function (event) {
    processing = false;
    $grid.jqxGrid("render"); // repaint grid if scroll bar disappears

    setTimeout(() => {
      setBtnEnableState();
    }, 50);
  });

  const getPagingOptions = (options = {}) => {
    const orgRenderStatusbar = options.renderstatusbar;

    return {
      autoheight: false,
      pageable: true,
      pagesize: pagesize,
      pagesizeoptions: pagesizeoptions,
      showstatusbar: true,
      renderstatusbar: (statusbar) => {
        if (orgRenderStatusbar) {
          orgRenderStatusbar(statusbar);

          statusbar.css({
            display: "flex",
            "justify-content": "space-between",
            "align-items": "center",
          });
        }

        const $div = $("<div>", { id: "status-bar", style: "padding:4px;" });

        $btn.on("click", () => {
          if (processing == false) {
            const datainfo = $grid.jqxGrid("getdatainformation");
            const totalRecords = datainfo.rowscount;

            if (totalRecords <= increment) {
              $grid.jqxGrid("updatebounddata", "data");
              setBtnDisableState(true);
              return;
            }

            // Get current selected page size
            increment = $grid.jqxGrid("pagesize") + increment;
            $grid.jqxGrid({ pagesize: increment });

            processing = true;
            setBtnDisableState(true);
          }
        });

        $div.append($btn);

        statusbar.append($div);
      },
      rendergridrows: function (obj) {
        return obj.data;
      },
    };
  };

  return (options = {}, hooks = []) => {
    options.source = source;

    hookFns($grid, { ...options, ...getPagingOptions(options) })(hooks);

    return {
      $grid,
      options,
    };
  };
}
